import algoliasearch from 'algoliasearch/lite';
import React, { useMemo } from 'react';
import { InstantSearch } from 'react-instantsearch-dom';

import CourierBaseLogo from '../../assets/svg/courier-base-logo.svg';
import LibrarySearchBox from '../LibrarySearch/LibrarySearchBox';
import LibrarySearchHits from '../LibrarySearch/LibrarySearchHits';
import LibrarySearchRangeFilter from '../LibrarySearch/LibrarySearchRangeFilter';
import LibrarySearchTagFilter from '../LibrarySearch/LibrarySearchTagFilter';

const HomepageLibrary = () => {
  const searchClient = useMemo(
    () =>
      algoliasearch(
        process.env.GATSBY_ALGOLIA_APP_ID,
        process.env.GATSBY_ALGOLIA_SEARCH_KEY,
      ),
    [],
  );

  return (
    <div className="overflow-hidden bg-black-magic">
      <InstantSearch
        indexName={process.env.GATSBY_ALGOLIA_INDEX_NAME}
        searchClient={searchClient}
      >
        <div
          className="pt-12 pb-16 homepage-grid-container gap-y-6"
          data-component-id="homepage_library"
        >
          <h2 className="order-1 mb-6 col-span-full stink-h2 text-smoke lg:col-span-7 lg:mb-0">
            Library
          </h2>
          <div className="order-2 mt-2 sm:self-end sm:col-span-4 stink-body-3 col-span-full sm:order-1 sm:mt-0">
            <LibrarySearchTagFilter attribute="tags.name" />
          </div>
          <div className="order-2 mt-2 sm:self-end sm:col-span-4 stink-body-3 col-span-full sm:order-1 sm:mt-0">
            <LibrarySearchRangeFilter
              defaultRefinement={`${process.env.GATSBY_ALGOLIA_INDEX_NAME}`}
              items={[
                {
                  label: 'Sort by Relevance',
                  value: `${process.env.GATSBY_ALGOLIA_INDEX_NAME}`,
                },
                {
                  label: 'Sort by Newest',
                  value: `${process.env.GATSBY_ALGOLIA_INDEX_NAME}_date_desc`,
                },
                {
                  label: 'Sort by Oldest',
                  value: `${process.env.GATSBY_ALGOLIA_INDEX_NAME}_date_asc`,
                },
              ]}
            />
          </div>
          <div
            className="order-1 lg:col-span-5 col-span-full sm:col-span-4 sm:order-2 "
            id="search-section"
          >
            <LibrarySearchBox />
          </div>
        </div>
        <div className="">
          <LibrarySearchHits />
        </div>
      </InstantSearch>
      <div className="homepage-grid-container">
        <CourierBaseLogo className="transform translate-y-[40%] fill-current col-span-full text-oatmeal lg:px-16 sm:px-8 opacity-30" />
      </div>
    </div>
  );
};

export default HomepageLibrary;
